import { render, staticRenderFns } from "./OrganismBuildingLabels.vue?vue&type=template&id=5f7a91dc&scoped=true&"
import script from "./OrganismBuildingLabels.vue?vue&type=script&lang=js&"
export * from "./OrganismBuildingLabels.vue?vue&type=script&lang=js&"
import style0 from "./OrganismBuildingLabels.vue?vue&type=style&index=0&id=5f7a91dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7a91dc",
  null
  
)

export default component.exports